import PremiumHeader from "@/components/premium/PremiumHeader";
import SEO from "@/components/SEO";
import PremiumFooter from "@/components/premium/PremiumFooter";
import StickyContactBar from "@/components/premium/StickyContactBar";
import PricingSection from "@/components/premium/home/PricingSection";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const MonthlyRatesPage = () => {
  const included = [
    "Fully Furnished", "High-Speed WiFi", "Washer / Dryer", "Private Parking",
    "3-Min Walk to Beach", "Fenced Backyard", "Game Room", "Ping Pong Table",
    "Beach Chairs + Surfboard", "Beach Wagon", "Full Kitchen", "Pet Friendly",
  ];

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <SEO
        title="Monthly Rates from $4,250 | Furnished Beach Rental Indialantic FL | Paradise Beach Rental"
        description="Transparent monthly pricing for our furnished Indialantic beach house: $4,250/mo standard or $4,500/mo all-inclusive. 90-day minimum, up to 9 months. No nightly rates, no hidden fees."
        path="/monthly-rates"
      />
      <PremiumHeader />
      <main>
        <section className="pt-32 pb-20 bg-[#0A1628]">
          <div className="container-premium text-center">
            <div className="gold-line mx-auto mb-6" />
            <span className="label-sm text-[#C9A962]">Monthly Rates</span>
            <h1 className="headline-xl text-white mt-4 mb-6">Transparent Monthly Pricing</h1>
            <p className="body-lg text-white/70 max-w-2xl mx-auto">
              Two simple options. 90-day minimum, up to 9 months. No nightly rates, no hidden fees.
            </p>
          </div>
        </section>

        <PricingSection />

        <section className="section-lg bg-[#F7F3ED]">
          <div className="container-premium">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="text-center mb-10"
            >
              <div className="gold-line mx-auto mb-4" />
              <h2 className="headline-md text-[#0A1628]">What's Included in Every Stay</h2>
            </motion.div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
              {included.map((item, i) => (
                <div key={i} className="flex items-center gap-2 bg-white p-4" data-testid={`included-item-${i}`}>
                  <Check className="w-4 h-4 text-[#C9A962] flex-shrink-0" />
                  <span className="font-body text-sm text-[#0A1628]/75">{item}</span>
                </div>
              ))}
            </div>

            <p className="text-center text-sm text-[#0A1628]/50 mt-10 max-w-2xl mx-auto">
              * Pet-friendly with one-time $150 cleaning fee — no recurring pet rent.
              Contact us for exact pricing based on your move-in date.
            </p>

            <div className="text-center mt-10">
              <Link to="/contact">
                <Button className="bg-[#0A1628] text-white hover:bg-[#1E3A5F] rounded-none px-10 py-5 font-medium">
                  Request Your Dates
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <PremiumFooter />
      <StickyContactBar />
    </div>
  );
};

export default MonthlyRatesPage;
